// Kept apart from `reduction-labels.tsx` because `routes.tsx` is in the app's initial bundle; importing
// the full labels object there would pull it, and the service domain code it imports, into every page.
export const reductionRouteLabels = {
  landing: "Reduce",
  wizard: "Create Plan",
  roadmap: "Plan",
};
